import React, { Component } from 'react';

import Slider from 'react-slick';

import {
    settings,
    WorkSlider,
    Title,
    SlideButton,
    Icon,
} from './slider-settings';

class SliderWork extends Component {
    Navigation = () => {
        const {
            arrowsColorBG,
            arrowsColorHoverBG,
            arrowsColor,
            arrowsColorHover,
        } = this.props;

        return (
            <div className="work__slider--navigation">
                <SlideButton
                    onClick={this.previous}
                    buttonColor={arrowsColorBG}
                    buttonHoverColor={arrowsColorHoverBG}
                    iconHoverColor={arrowsColorHover}
                    className="button prev">
                    <Icon
                        iconColor={arrowsColor}
                        className="icon icon-arrow_right"
                    />
                </SlideButton>

                <SlideButton
                    onClick={this.next}
                    buttonColor={arrowsColorBG}
                    buttonHoverColor={arrowsColorHoverBG}
                    iconHoverColor={arrowsColorHover}
                    className="button next">
                    <Icon
                        iconColor={arrowsColor}
                        className="icon icon-arrow_right"
                    />
                </SlideButton>
            </div>
        );
    };

    Slides = () => {
        return (
            this.props.slides &&
            this.props.slides.map(slide => {
                const { id, url, title } = slide.work_slides_image;
                const { work_slides_title: slideTitle } = slide;
                const { slider_img } = slide.work_slides_image.sizes;
                const { titleColor } = this.props;

                return (
                    <div key={id} className="work__slider--item">
                        {slideTitle && (
                            <Title
                                textColor={titleColor}
                                className="work__slider--title">
                                {slideTitle}
                            </Title>
                        )}
                        {url && (
                            <div
                                id={title}
                                className="work__slider--image"
                                style={{
                                    backgroundImage: `url(${slider_img})`,
                                }}
                            />
                        )}
                    </div>
                );
            })
        );
    };

    next = () => {
        this.slider.slickNext();
    };

    previous = () => {
        this.slider.slickPrev();
    };

    render() {
        return this.props.slides ? (
            <WorkSlider
                bgColor={this.props.bgColor}
                dotColor={this.props.dotsColor}
                className="work__slider">
                <div className="content-container">
                    <Slider
                        ref={slider => (this.slider = slider)}
                        {...settings}>
                        {this.Slides()}
                    </Slider>
                </div>
                {this.Navigation()}
            </WorkSlider>
        ) : null;
    }
}

export default SliderWork;



// WEBPACK FOOTER //
// ./src/components/Pages/Work/SliderWork.jsx